<template>
  <v-container fluid fill-height>
    <v-row>
      <v-col cols="12">
        <v-row justify="center" align="center">
          <v-col cols="12" style="max-width:600px">
            <v-card>
              <v-toolbar dark color="primary">
                <v-spacer></v-spacer>
                <img src="@/assets/placemint.png" width="150" />
                <v-spacer></v-spacer>
              </v-toolbar>
              <div class="text-center pt-3">
                <div class="font-weight-light display-1">
                  Sign up for a free trial
                </div>
                <div>
                  Get started with a 30 day trial. No card details required
                </div>
              </div>
              <v-stepper v-model="tab" class="elevation-0">
                <v-stepper-header class="elevation-2">
                  <v-stepper-step :complete="tab > 1" step="1" editable
                    >About you</v-stepper-step
                  >
                  <v-divider></v-divider>
                  <v-stepper-step :complete="tab > 2" step="2" editable
                    >Your Company</v-stepper-step
                  >
                </v-stepper-header>

                <v-stepper-items>
                  <v-stepper-content step="1">
                    <v-form ref="userForm" lazy-validation>
                      <v-container pa-0>
                        <v-row class="grey lighten-5 px-4" dense>
                          <v-col cols="12" class="py-0">
                            <v-text-field
                              label="Full Name"
                              v-model="user.fullName"
                              :rules="[rules.required]"
                              type="text"
                              required
                              outlined
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" class="py-0">
                            <v-text-field
                              label="Email Address"
                              v-model="user.email"
                              :rules="[rules.email]"
                              type="email"
                              required
                              outlined
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" class="py-0">
                            <v-text-field
                              label="Password"
                              v-model="user.password"
                              :rules="[rules.password]"
                              type="password"
                              required
                              outlined
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" class="py-0">
                            <v-text-field
                              label="Confirm Password"
                              v-model="user.confirmPassword"
                              :rules="[rules.confirmPassword(user.password)]"
                              type="password"
                              required
                              outlined
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-form>
                  </v-stepper-content>

                  <v-stepper-content step="2">
                    <v-form ref="companyForm" lazy-validation>
                      <v-container pa-0>
                        <v-row class="grey lighten-5 px-4" dense>
                          <v-col cols="12" class="py-0">
                            <v-text-field
                              label="Company Name"
                              v-model="company.name"
                              :rules="[rules.required]"
                              type="text"
                              required
                              outlined
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" class="py-0">
                            <v-text-field
                              v-model="company.address"
                              label="Address"
                              required
                              :rules="[rules.required]"
                              outlined
                            ></v-text-field>
                          </v-col>
                          <v-col cols="8" sm="8" class="py-0">
                            <v-text-field
                              v-model="company.city"
                              label="City"
                              required
                              :rules="[rules.required]"
                              outlined
                            ></v-text-field>
                          </v-col>
                          <v-col cols="4" sm="4" class="py-0">
                            <v-text-field
                              v-model="company.postcode"
                              label="Postcode"
                              required
                              :rules="[rules.required]"
                              outlined
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" class="py-0">
                            <v-text-field
                              label="Location Name"
                              v-model="company.location"
                              :rules="[rules.required]"
                              type="text"
                              required
                              outlined
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="4" class="py-0">
                            <v-text-field
                              label="Location Phone"
                              v-model="company.phone"
                              :rules="[rules.phone]"
                              type="text"
                              required
                              outlined
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="8" class="py-0">
                            <v-text-field
                              label="Location Email"
                              v-model="company.companyEmail"
                              :rules="[rules.email]"
                              type="email"
                              required
                              outlined
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-form>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>

              <v-container py-0 px-7>
                <v-row>
                  <v-col>
                    <v-btn
                      block
                      color="primary"
                      :loading="loading"
                      :disabled="loading"
                      @click="submit()"
                      >{{ tab == 1 ? 'Continue' : 'Create Account' }}</v-btn
                    >
                  </v-col>
                </v-row>
                <v-alert
                  v-if="error"
                  :value="true"
                  type="error"
                  class="title font-weight-medium text-center ma-0 pa-1"
                  >Authentication Failed</v-alert
                >
              </v-container>

              <v-divider></v-divider>

              <v-card-text>
                <v-list class="text-center">
                  Already have an account?
                  <router-link
                    color="active"
                    :to="{ path: '/signin' }"
                    class="routerLinkStyle"
                    >Sign in</router-link
                  >
                </v-list>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import rules from '@/rules.js';

export default {
  data() {
    return {
      user: {
        fullName: '',
        email: '',
        password: '',
        confirmPassword: ''
      },
      company: {
        name: '',
        address: '',
        city: '',
        postcode: '',
        location: '',
        phone: '',
        companyEmail: ''
      },
      rules: rules,
      tab: 1
    };
  },
  computed: {
    ...mapState({
      account: state => state.account,
      alert: state => state.alert
    }),
    ...mapState({
      alert: state => state.alert
    }),
    loading() {
      return this.account.loading;
    },
    error() {
      return this.account.error;
    }
  },
  methods: {
    ...mapActions('account', ['register', 'clearError']),
    submit() {
      if (this.tab == 1) {
        if (this.$refs.userForm.validate()) {
          this.tab = 2;
        }
      } else {
        if (this.$refs.companyForm.validate()) {
          var payload = { user: this.user, company: this.company };
          console.log(payload);
          this.register(payload);
        }
      }
    }
  },
  mounted() {
    this.clearError();
  }
};
</script>
